import { Keyword, LengthPercentage, Number } from "@siteimprove/alfa-css";
import { Parser } from "@siteimprove/alfa-parser";
import { Selective } from "@siteimprove/alfa-selective";
import { Longhand } from "../longhand.js";
import { Resolver } from "../resolver.js";
const { either } = Parser;
const parse = either(Keyword.parse("baseline", "sub", "super", "text-top", "text-bottom", "middle", "top", "bottom"), LengthPercentage.parse);
/**
 * {@link https://developer.mozilla.org/en-US/docs/Web/CSS/vertical-align}
 * @internal
 */
export default Longhand.of(Keyword.of("baseline"), parse, (value, style) => value.map((verticalAlign) => {
    // We need the type assertion to help TS break a circular type reference:
    // this -> style.computed -> Longhands.Name -> Longhands.longhands -> this.
    const lineHeight = style.computed("line-height").value;
    const fontSize = style.computed("font-size").value;
    const base = Selective.of(lineHeight)
        .if(isNormal, () => fontSize.scale(1.2))
        .if(Number.isNumber, (value) => fontSize.scale(value.value))
        .get();
    return Selective.of(verticalAlign)
        .if(LengthPercentage.isLengthPercentage, LengthPercentage.resolve(Resolver.lengthPercentage(base, style)))
        .get();
}));
/**
 * isKeyword doesn't refine the type enough since it doesn't look at the value.
 */
function isNormal(value) {
    return Keyword.isKeyword(value) && value.value === "normal";
}
//# sourceMappingURL=vertical-align.js.map